/* eslint-disable angular/controller-name, angular/controller-as */

angular.module("digiexam").controller("LoginController", LoginController);

function LoginController(
	$scope,
	$timeout,
	dxDialog
) {
	"use strict";

	$scope.errorMessage = "";

	$scope.$on("auth:loginsuccess", function onLoginSuccess() {
		$scope.errorMessage = "";
		$scope.success();
		$timeout(function popupTimeoutFunction() {
			dxDialog.closeMostRecent();
		}, 10);
	});

	$scope.$on("auth:loginfailed", function onLoginFail() {
		$scope.errorMessage = "LoginFailedDescription";
	});
}
